import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import {
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../../../config/constants';

import '../style.scss';

const TextWithImageFullscreen = ({ entity, className, hasSummaryLinks = false, lazyload = true }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed']);
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'], null));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const image = entity.getIn(['field_image', 0, 'styles'], '');
  const isDownloadAction = linkUrl ? linkUrl.indexOf('.pdf') > 0 : false;

  const classNames = c('ParagraphTextWithImage', 'fullScreen', {
    'active-theme-background-color': isDownloadAction,
  }, className);

  return (
    <div className={classNames}>
      <div className="imageWrapper">
        <div className="ParagraphTextWithImage__image">
          <Image
            lazyload={lazyload}
            includeWebP
            src={{
              [SCREEN_MOBILE]: image.getIn(['crop_3_4']),
              [SCREEN_NORMAL]: image.getIn(['cropped_3_4_large']),
              [SCREEN_WIDE]: image.getIn(['cropped_4_3_large']),
            }}
          />
        </div>
      </div>
      <div className="textWrapper">
        <div className="container">
          <div className="ParagraphTextWithImage__title">
            <h2>{title}</h2>
          </div>
          {!hasSummaryLinks && (
            <div className="ParagraphTextWithImage__text">
              <WysiwygField property="schema:text" html={text} />
            </div>
          )}
          {linkUrl && !hasSummaryLinks && (
            <div className="ParagraphTextWithImage__link">
              <CoreLink
                className={`Button Button--${isDownloadAction ? 'inverted' : 'primary'}`}
                href={linkUrl}
              >
                {linkTitle}
                <i className={`icon ${isDownloadAction ? 'icon-download' : 'icon-arrow-right'}`} />
              </CoreLink>
            </div>
          )}
          {hasSummaryLinks
            && (
              <>
                {entity.get('field_links', Immutable.Map()).map((link) => {
                  const linkUrl = link.get('alias', link.get('uri', null));
                  const linkTitle = link.get('title', '');

                  return (
                    <div key={linkUrl} className="ParagraphTextWithImage__indexLink">
                      <CoreLink
                        href={linkUrl}
                      >
                        <span>
                          {linkTitle}
                        </span>
                        <i className="icon icon-arrow-right-filled icon-variant-3" />
                      </CoreLink>
                    </div>
                  );
                })}
              </>
            )}
        </div>
      </div>
    </div>
  );
};

export default TextWithImageFullscreen;
